<template>
    <button id="jp-en-button" @click="$store.commit('toggleLang')">
        <img id="exit-button-img" src="@/assets/jp_en.png" alt="JP_EN" />
    </button>
</template>

<script>
export default {
  name: 'ToggleLangButton',
}
</script>

<style scoped>
#jp-en-button {
  z-index: 300;
  outline: none;
  position: absolute;
  right: 0px;
  top: 0px;
  height: auto;
  width: 100px;
  height: fit-content;
}
#jp-en-button img {
  width: 100%;
}
</style>
